<div class="item-content" [ngClass]="getClassNames()" [attr.data-icon-name]="iconName">
    <skl-icon [name]="iconName"></skl-icon>
    @if (item.dynamicLabel) {
        <div class="item-content__label">{{item.dynamicLabel(context)}}</div>
    } @else {
        <div class="item-content__label">{{item.label}}</div>
    }
</div>